// AIDEV-NOTE: Shared hook for polling /api/service-status.
// All service degradation display components consume this hook.
// Polls every 30s; returns { degraded: boolean }.

import { useEffect, useState } from "react";

const POLL_INTERVAL_MS = 30_000;

export function useServiceHealth() {
    const [degraded, setDegraded] = useState(false);

    useEffect(() => {
        let mounted = true;

        async function checkStatus() {
            try {
                const res = await fetch("/api/service-status");
                if (res.ok) {
                    const data = await res.json();
                    if (mounted) setDegraded(data.degraded);
                } else if (mounted) {
                    // AIDEV-NOTE: Clear stale degraded state on non-OK response
                    // to avoid sticky false positives when health can't be confirmed.
                    setDegraded(false);
                }
            } catch {
                // Network error — clear degraded state to avoid sticky false positives
                if (mounted) setDegraded(false);
            }
        }

        checkStatus();
        const interval = setInterval(checkStatus, POLL_INTERVAL_MS);

        return () => {
            mounted = false;
            clearInterval(interval);
        };
    }, []);

    return { degraded };
}
